import * as React from 'react';

function Matbia(props) {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect
                x="0.25"
                y="0.25"
                width="31.5"
                height="31.5"
                rx="15.75"
                fill="#44479D"
            />
            <rect
                x="0.5"
                y="0.5"
                width="31"
                height="31"
                rx="15.5"
                stroke="#B0C9EB"
            />
            <path
                d="M13.4895 16.3748C13.592 16.008 13.379 15.6277 13.0123 15.5252C12.6455 15.4227 12.2654 15.6358 12.1629 16.0026C12.1292 16.124 12.1292 16.2534 12.1629 16.3748H13.4895Z"
                fill="#FCB646"
            />
            <path
                d="M27.9528 18.1238H24.9962C24.9706 18.1238 24.9504 18.1035 24.9491 18.0779V16.422C24.9491 16.3964 24.9693 16.3748 24.9962 16.3748H26.2042C26.2298 16.3748 26.2501 16.3545 26.2501 16.3289V15.799C26.2501 15.7734 26.2298 15.7531 26.2042 15.7518H24.372C24.3464 15.7518 24.3262 15.772 24.3262 15.799V18.0631C24.3262 18.0887 24.306 18.1089 24.2804 18.1089H22.6248C22.5992 18.1089 22.579 18.0887 22.5776 18.0631V14.05C22.5776 14.0244 22.5978 14.0041 22.6248 14.0041H27.9542C27.9798 14.0041 28 14.0244 28 14.05V18.0779C28 18.1035 27.9798 18.1238 27.9542 18.1238"
                fill="white"
            />
            <path
                d="M22.0613 18.1238H16.7278C16.7036 18.1238 16.6833 18.1035 16.6833 18.0793V14.0459C16.6833 14.0217 16.7036 14.0014 16.7278 14.0014H18.3888C18.4131 14.0014 18.4333 14.0217 18.4333 14.0459V16.3303C18.4333 16.3545 18.4535 16.3748 18.4778 16.3748H20.314C20.3383 16.3748 20.3585 16.3545 20.3585 16.3303V15.7949C20.3585 15.7706 20.3383 15.7504 20.314 15.7504H19.1006C19.0764 15.7504 19.0562 15.7302 19.0562 15.7059V14.0446C19.0562 14.0203 19.0764 14.0001 19.1006 14.0001H22.0639C22.0882 14.0001 22.1084 14.019 22.1084 14.0432V18.0766C22.1084 18.1008 22.0882 18.1211 22.0639 18.1211"
                fill="white"
            />
            <path
                d="M10.3671 18.1237H5.04179C5.01887 18.1237 5 18.1048 5 18.0819V16.4165C5 16.3936 5.01887 16.3747 5.04179 16.3747H5.62151C5.64443 16.3747 5.66331 16.3558 5.66331 16.3329V15.7921C5.66331 15.7692 5.64443 15.7503 5.62151 15.7503H5.04449C5.02157 15.7503 5.0027 15.7315 5.0027 15.7085V14.0432C5.0027 14.0202 5.02157 14.0013 5.04449 14.0013H7.37145C7.39437 14.0013 7.41325 14.0202 7.41325 14.0432V16.3329C7.41325 16.3558 7.43212 16.3747 7.45504 16.3747H8.61987C8.64279 16.3747 8.66167 16.3558 8.66167 16.3329V15.7921C8.66167 15.7692 8.64279 15.7503 8.61987 15.7503H8.07925C8.05633 15.7503 8.03746 15.7315 8.03746 15.7085V14.0418C8.03746 14.0189 8.05633 14 8.07925 14H10.3685C10.3914 14 10.4103 14.0189 10.4103 14.0418V18.0805C10.4103 18.1034 10.3914 18.1223 10.3685 18.1223"
                fill="white"
            />
            <path
                d="M15.6547 16.3208V14.0581C15.6547 14.0284 15.6304 14.0041 15.6008 14.0041H10.9468C10.9172 14.0041 10.8929 14.0284 10.8929 14.0581V15.6992C10.8929 15.7289 10.9172 15.7531 10.9468 15.7531H11.7355C11.7571 15.7531 11.776 15.7396 11.7841 15.7208C11.8501 15.5765 11.9445 15.447 12.0631 15.3405C12.3678 15.0627 12.7992 14.9723 13.1902 15.1045H13.1943C13.7066 15.2798 14.0247 15.7936 13.9533 16.3303C13.9492 16.3559 13.9263 16.3761 13.9007 16.3761H10.9482C10.9185 16.3761 10.8943 16.4004 10.8943 16.4301V18.0712C10.8943 18.1008 10.9185 18.1251 10.9482 18.1251H16.2236C16.2533 18.1251 16.2775 18.1008 16.2775 18.0712V16.4314C16.2775 16.4017 16.2533 16.3775 16.2236 16.3775H15.71C15.6803 16.3775 15.656 16.3532 15.656 16.3235"
                fill="white"
            />
        </svg>
    );
}

export default Matbia;
